var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6674,11.5747 L11.6678,11.5742 C11.7102,11.5174 11.7624,11.485 11.8113,11.4718 L11.6815,10.989 L11.8113,11.4718 C11.8593,11.4589 11.91,11.4628 11.9586,11.4853 C11.9588,11.4853 11.9589,11.4854 11.959,11.4854 L15.5648,13.1713 C15.5651,13.1714 15.5654,13.1715 15.5657,13.1717 C15.6208,13.1981 15.6755,13.2495 15.7116,13.327 C15.748,13.4051 15.7594,13.4982 15.7412,13.5879 C15.7411,13.5883 15.741,13.5886 15.7409,13.589 L14.9681,17.2425 C14.9681,17.2426 14.9681,17.2426 14.9681,17.2426 C14.9501,17.3275 14.9078,17.3952 14.8573,17.439 C14.8078,17.482 14.7533,17.5 14.7035,17.5 L14.7031,17.5 C6.76584,17.5 0.249999989,10.4705 0.249999989,1.6875 L0.249999989,1.6874 C0.249999989,1.5988 0.27776,1.51753 0.32212,1.45668 C0.36597,1.39653 0.42057,1.36291 0.47148,1.35007 C0.4715,1.35006 0.47153,1.35006 0.47155,1.35005 L3.82131,0.50675 C3.82152,0.5067 3.82172,0.506649 3.82193,0.506599 C3.87431,0.493768 3.9303,0.500328421 3.98334,0.529501 C4.03766,0.559453 4.09025,0.614704 4.12249,0.694626 L5.66868,4.63038 C5.6978,4.70453 5.70454,4.78948 5.6863,4.87026 C5.66808,4.95089 5.62785,5.01542 5.57987,5.05798 L5.5787,5.05903 L3.62577,6.80278 L3.35672,7.04301 L3.49982,7.37411 C4.72571,10.2105 6.82262,12.5033 9.4403,13.8497 L9.8157,14.0428 L10.069,13.7051 L11.6674,11.5747 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFill);
export default __webpack_public_path__ + "static/media/phoneFill.46fdbd09.svg";
export { ForwardRef as ReactComponent };